import _APIInstance from "@/config/configApi";
import { API } from "@constants/common";
import { Seo } from "@/models/seo";
import { Report } from "@/models/report";
import _APIInstanceServer from "@/config/configApiServer";

export default class SeoServices {
  static async getSeoById(
    id: string | number,
    lang: string | undefined
  ): Promise<Seo | any> {
    try{
      const response = await _APIInstanceServer
      .get(`${API.SEO.GET_ONE}`.replace(":id", `${id}`), {
        headers: {
          lang: `${lang}`,
        },
      });
      return response.data
    } catch (error: any) {
      throw error?.response?.data;
    }
  }

  static async getAllReportsSeo(
    lang: string | undefined
  ): Promise<Report[] | any> {
    return await _APIInstance
      .get(API.SEO.GET_ALL_REPORTS, {
        headers: {
          lang: `${lang}`,
        },
      })
      .then((res) => Promise.resolve(res.data))
      .catch((res) => Promise.reject(res));
  }

  static async getPrivacyPolicy(
    id: string | number,
    lang: string | undefined
  ): Promise<Seo | any> {
    return await _APIInstance
      .get(`${API.SEO.GET_PRIVACY_POLICY}`.replace(":id", `${id}`), {
        headers: {
          lang: `${lang}`,
        },
      })
      .then((res) => Promise.resolve(res.data))
      .catch((res) => Promise.reject(res));
  }

  static async getUrls(lang: string | undefined): Promise<Seo | any> {
    return await _APIInstance
      .get(`${API.SEO.GET_URLS}`, {
        headers: {
          lang: `${lang}`,
        },
      })
      .then((res) => Promise.resolve(res.data))
      .catch((res) => Promise.reject(res));
  }
}
